<template>
  <div v-if="user">
    <h2>Dostęp do wdrożeń dla użytkownika: {{ user.login }}</h2>
    <v-btn color="primary" @click="openCreateDialog">Dodaj</v-btn>
    <data-table :headers="headers" :items="items">
      <template v-slot:item.actions="{ item }">
        <v-btn color="error" @click="deleteCompanyUser(item)"
          >Usuń dostęp</v-btn
        >
      </template></data-table
    >
    <v-dialog width="800" persistent v-model="createDialog">
      <v-card>
        <v-card-title>
          Nowy dostęp
        </v-card-title>
        <v-card-text>
          <v-select
            label="Wybierz wdrożenie"
            :loading="loading"
            v-model="createVm.companyId"
            :items="companies"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-card-text>
        <v-card-actions> <v-btn @click="create">Zapisz</v-btn> </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "../components/DataTable.vue";
export default {
  components: { DataTable },
  data() {
    return {
      loading: false,
      items: [],
      user: null,
      createVm: {},
      createDialog: false,
      companies: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Nazwa wdrożenia",
          value: "companyName"
        },
        {
          text: "Opcje",
          value: "actions"
        }
      ]
    };
  },
  computed: {
    userId() {
      return this.$route.params.userId;
    }
  },
  methods: {
    async get() {
      const response = await this.$http.get(
        "User/GetCompanyUsers?userId=" + this.userId
      );
      this.items = response.data;
    },
    async getUser() {
      const response = await this.$http.get("User/GetById?id=" + this.userId);
      this.user = response.data;
    },
    async openCreateDialog() {
      this.createVm = { userId: this.userId, companyId: null };
      await this.getCompanies();
      this.createDialog = true;
    },
    async create() {
      if (!this.createVm.companyId) {
        return;
      }
      this.loading = true;

      try {
        const response = await this.$http.post(
          "User/CreateCompanyUser",
          this.createVm
        );
        this.items.push(response.data);
      } finally {
        this.loading = false;
        this.createDialog = false;
        this.createVm = { userId: this.userId, companyId: null };
      }
    },
    async getCompanies() {
      const response = await this.$http.get("Company/GetSimpleCompanies");
      this.companies = response.data;
    },
    async deleteCompanyUser(item) {
      const response = await this.$http.delete(
        "User/DeleteCompanyUser?id=" + item.id
      );
      const indexOf = this.items.indexOf(response);
      this.items.splice(indexOf, 1);
    }
  },
  async mounted() {
    await this.getUser();
    await this.get();
  }
};
</script>
